import { RadioGroup as HUIRadioGroup } from '@headlessui/react';
import classNames from 'classnames';
import { useFormFieldState } from './hooks';

interface InlineSelectOption {
  label: string;
  value: string;
}

interface InlineSelectProps {
  name: string;
  label: string;
  options: InlineSelectOption[];
}

export function FormInlineSelect(props: InlineSelectProps) {
  const { formContext } = useFormFieldState({ name: props.name });
  const value = formContext.watch(props.name);

  return (
    <HUIRadioGroup
      value={value}
      onChange={(v) =>
        formContext.setValue(props.name, v, { shouldDirty: true })
      }
    >
      <HUIRadioGroup.Label className="block text-gray-500 text-xs font-medium uppercase tracking-wider mb-1">
        {props.label}
      </HUIRadioGroup.Label>
      <div className="flex gap-3">
        {props.options.map((o) => (
          <HUIRadioGroup.Option
            key={`${o.label}-${o.value}`}
            value={o.value}
            className="flex-1"
          >
            {({ checked }) => (
              <div
                className={classNames(
                  'flex items-center justify-center cursor-pointer px-4 py-3 text-sm font-medium transition-all text-center rounded-lg border',
                  checked
                    ? 'bg-blue text-white border-blue'
                    : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50',
                )}
              >
                {o.label}
              </div>
            )}
          </HUIRadioGroup.Option>
        ))}
      </div>
    </HUIRadioGroup>
  );
}
